import { render, staticRenderFns } from "./CheckoutAdd.vue?vue&type=template&id=20c0cefd&"
import script from "./CheckoutAdd.vue?vue&type=script&lang=js&"
export * from "./CheckoutAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports